import DashboardCTA from '../DashboardCTA/DashboardCTA';
import { FormattedMessage } from 'react-intl';
import { PaymentCardSVG } from '@svgComponents/paymentCardSVG/PaymentCardSVG';
import messages from './OverduePayments.messages';
import styles from './OverduePayments.module.css';
import dashboardCTAStyles from '../DashboardCTA/DashboardCTA.module.css';
import { MoneyWithDecimals } from '../../../../myAccount/ui/moneyWithDecimals';
import { Button } from '@iwoca/orion';

export const OverduePayments = ({
    overduePaymentAmount,
    onClick,
    isBottomAction = false
}: {
    overduePaymentAmount: number;
    onClick: () => void;
    isBottomAction?: boolean;
}) => {
    return (
        <DashboardCTA
            data-testid="overdue-payment-action"
            title={<FormattedMessage {...messages.overdueRepaymentTitle} />}
            className={
                isBottomAction
                    ? ''
                    : dashboardCTAStyles.nonBottomDashboardAction
            }
            icon={<PaymentCardSVG />}
            description={
                <FormattedMessage
                    {...messages.overdueRepayment}
                    values={{
                        overduePaymentAmount: (
                            <span className={styles.overdueAmount}>
                                <MoneyWithDecimals
                                    value={overduePaymentAmount}
                                />
                            </span>
                        ),
                        link: (
                            <a
                                href="https://support.iwoca.co.uk/en/articles/1608757-how-we-can-help-if-you-miss-a-payment-or-you-re-struggling-to-repay"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <FormattedMessage
                                    {...messages.overdueRepaymentLink}
                                />
                            </a>
                        )
                    }}
                />
            }
            cta={
                <Button variant="primary" onClick={onClick}>
                    <FormattedMessage {...messages.overdueRepaymentCTA} />
                </Button>
            }
        />
    );
};
